var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.details)?_c('div',[_c('Header',{attrs:{"info":_vm.details.info}}),_c('Body',{attrs:{"details":_vm.details.data,"info":_vm.details.info}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }